import { motion } from "framer-motion";
import { IMAGES } from "../../data/content";
import { Container, CTAButton, FadeUp, MaskedLine, SectionLabel, scrollToHash } from "./ui";

const Aviation = () => (
  <section id="aviation" className="relative overflow-hidden bg-ink py-32 md:py-48" data-testid="aviation-section">
    <div className="absolute inset-0" aria-hidden="true">
      <img src={IMAGES.aviationWing} alt="" className="h-full w-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-ink/[0.82]" />
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(ellipse at center, transparent 0%, rgba(10,10,10,0.55) 100%)" }}
      />
    </div>

    <Container className="relative">
      <div className="mx-auto max-w-[820px] text-center">
        <FadeUp y={16}>
          <SectionLabel>Travel — Private Aviation</SectionLabel>
        </FadeUp>
        <h2 className="mt-8 font-serif font-medium leading-[0.95] text-ivory text-[clamp(48px,7vw,110px)]">
          <MaskedLine delay={0.1}>QUAND LE TEMPS</MaskedLine>
          <MaskedLine delay={0.2} className="text-champagne">
            COMPTE.
          </MaskedLine>
        </h2>
        <FadeUp delay={0.3} className="mt-8">
          <p className="mx-auto max-w-[560px] font-sans text-[15px] font-light leading-[1.8] text-neutral-300 md:text-base">
            Nous recherchons les meilleures solutions disponibles pour vos déplacements en
            aviation privée, notamment les opportunités d'empty leg.
          </p>
        </FadeUp>

        <svg viewBox="0 0 600 110" className="mx-auto mt-12 w-full max-w-[560px]" aria-hidden="true">
          <circle cx="12" cy="98" r="2.5" fill="#858585" />
          <motion.path
            d="M12 98 C 190 14, 420 14, 588 52"
            fill="none"
            stroke="#b8a47e"
            strokeWidth="1"
            strokeDasharray="2 6"
            initial={{ pathLength: 0 }}
            whileInView={{ pathLength: 1 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 3, ease: "easeInOut" }}
          />
          <motion.circle
            cx="588"
            cy="52"
            r="3"
            fill="#b8a47e"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: [0, 1, 0.35, 1] }}
            viewport={{ once: true }}
            transition={{ delay: 2.8, duration: 1.4 }}
          />
        </svg>

        <FadeUp delay={0.4} className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <CTAButton onClick={() => scrollToHash("#demande")} testid="aviation-cta-primary">
            Rechercher un vol privé
          </CTAButton>
          <CTAButton variant="secondary" onClick={() => scrollToHash("#demande")} testid="aviation-cta-secondary">
            Parler à un conseiller
          </CTAButton>
        </FadeUp>
      </div>
    </Container>
  </section>
);

export default Aviation;
